import { apiRequest } from './apiService';
import { useAuthStore } from '../store/authStore';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const uuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const value = Math.floor(Math.random() * 16);
    return (char === 'x' ? value : (value & 0x3) | 0x8).toString(16);
  });
};

export type ClientActivityType =
  | 'discovery.keyword_opened'
  | 'learning.course_accessed'
  | 'learning.topic_revisited'
  | 'learning.content_viewed';

export const recordClientActivity = async (
  type: ClientActivityType,
  target: { kind: 'course' | 'topic'; id: string }
): Promise<void> => {
  const token = useAuthStore.getState().token;
  if (!token) return;
  await apiRequest(`${API_BASE_URL}/activity`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      type,
      ...(target ? { target } : {}),
      clientEventId: uuid()
    })
  });
};
